import LinkFlowEditor from './link-flow-editor'

export async function loadVueFlowEditorDependency(resolve, reject) {
	try {
		const [vueCompositionApi] = await Promise.all([LinkVue.resource.loadLib('vueCompositionApi'), LinkVue.resource.loadLib('G6')])
		window.Vue.use(vueCompositionApi.default)
		const VueFlowEditor = await LinkVue.resource.loadLib('VueFlowEditor')
		window.Vue.use(VueFlowEditor)

		return {
			vueCompositionApi,
			VueFlowEditor,
		}
	} catch (e) {
		console.error(e)
		!!reject && reject(e)
	}
}

export const LinkFlowEditorInstaller = {
	install(Vue) {

		Vue.component(LinkFlowEditor.name, LinkFlowEditor)

		Vue.component('vue-flow-editor', async (resolve, reject) => {
			const {VueFlowEditor} = await loadVueFlowEditorDependency(resolve, reject)
			return VueFlowEditor.VueFlowEditor
		})

		Vue.component('vue-flow-edit-menu', async (resolve, reject) => {
			const {VueFlowEditor} = await loadVueFlowEditorDependency(resolve, reject)
			const {VueFLowEditMenu} = VueFlowEditor
			resolve(VueFLowEditMenu)
		})
		Vue.component('vue-flow-edit-menu-group', async (resolve, reject) => {
			const {VueFlowEditor} = await loadVueFlowEditorDependency(resolve, reject)
			const {VueFLowEditMenuGroup} = VueFlowEditor
			resolve(VueFLowEditMenuGroup)
		})
	},
}